import { Eye, HandHeart, Sparkles, BookOpen, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { SERVICES } from "@/lib/content";

const ICONS = { Eye, HandHeart, Sparkles, BookOpen };
const slug = (s) => s.toLowerCase().replace(/[^a-z]+/g, "-");

export default function Services({ onChoose }) {
  return (
    <section id="services" className="px-6 md:px-16 py-24 md:py-32" data-testid="services-section">
      <Reveal className="max-w-2xl">
        <p className="font-heading tracking-[0.35em] text-xs text-gold">SACRED OFFERINGS</p>
        <h2 className="font-display text-3xl md:text-5xl gold-text mt-4">Services</h2>
        <p className="mt-5 text-[#f7f1e1]/75 text-base md:text-lg">Choose the support your spirit is calling for. Each session is held with love, care and divine guidance.</p>
      </Reveal>
      <div className="grid sm:grid-cols-2 gap-6 md:gap-8 mt-14">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <Reveal key={s.key} delay={i * 0.12} className={i % 2 ? "sm:mt-12" : ""}>
              <article className="service-card glass rounded-3xl p-8 md:p-10 h-full flex flex-col" data-testid={`service-card-${slug(s.key)}`}>
                <div className="w-14 h-14 rounded-full border border-[#d4af37]/50 flex items-center justify-center text-gold mb-6">
                  <Icon size={24} strokeWidth={1.4} />
                </div>
                <h3 className="font-heading text-xl md:text-2xl text-gold-soft">{s.key}</h3>
                <p className="mt-4 text-[#f7f1e1]/75 leading-relaxed flex-1">{s.text}</p>
                <button onClick={() => onChoose(s.key)} data-testid={`service-request-btn-${slug(s.key)}`}
                  className="mt-8 self-start inline-flex items-center gap-2 font-heading text-xs tracking-widest text-gold hover:gap-4 transition-[gap] duration-300">
                  REQUEST THIS <ArrowRight size={16} />
                </button>
              </article>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}
